import React from 'react';
import { formatLabor, periodSummary } from '../../lib/historyList';

export const HistoryPeriodSummary = ({ events, loading, error, rangeLabel, searching }) => {
  const stats = periodSummary(events);
  const ready = !loading && !error;
  const metrics = [
    ['work-orders', 'Completed work orders', stats.workOrders, ''],
    ['logs', 'Maintenance logs', stats.logs, ''],
    ['equipment', 'Equipment serviced', stats.equipment, 'Linked equipment only'],
    ['labor-hours', 'Recorded labor hours', stats.withLabor ? formatLabor(stats.labor) : '—',
      `${stats.withLabor} of ${events.length} records include hours`],
  ];
  return <section className="history-period" aria-label="Period summary" data-testid="history-period-summary">
    <div className="history-period-heading">
      <h2 data-testid="history-period-label">{rangeLabel}{searching ? ' · Search results' : ''}</h2>
      <span data-testid="history-summary-record-count">{ready ? `${events.length} records · ${stats.requests} completed requests` : loading ? 'Loading…' : 'Summary unavailable'}</span>
    </div>
    <dl className="history-metrics">
      {metrics.map(([key, label, value, note]) => <div key={key} data-testid={`summary-card-${key}`}>
        <dt>{label}</dt>
        <dd data-testid={`history-summary-${key}`}>{ready ? value : '—'}</dd>
        {note && <p data-testid={`history-summary-${key}-note`}>{ready ? note : '\u00a0'}</p>}
      </div>)}
    </dl>
  </section>;
};